import { useEffect, useState } from "react";
import {
  DocumentNode,
  NetworkStatus,
  OperationVariables,
  useQuery,
} from "@apollo/client";
import useRetry from "../CustomizedDashboard/useRetry";

type UseQueryWithRetriesType = {
  query: DocumentNode;
  variables: OperationVariables;
  skip?: boolean;
};

const useQueryWithRetries = ({
  query,
  variables,
  skip = false,
}: UseQueryWithRetriesType) => {
  const [dataFromQuery, setDataFromQuery] = useState(null);

  const { data, error, loading, refetch, networkStatus } = useQuery(query, {
    variables: { ...variables },
    skip: skip,
    notifyOnNetworkStatusChange: true,
  });

  const { finalError, resetRetries } = useRetry({
    requestError: error,
    refetch,
  });

  useEffect(() => {
    if (!!data && !loading) {
      resetRetries();
      setDataFromQuery(data);
    }
  }, [data, loading]);

  return {
    data: dataFromQuery,
    // finalError is `unknown` from useRetry; coerce to boolean so the error flag
    // has a stable type. Consumers read it only as a truthy error indicator.
    error: !!finalError && networkStatus !== NetworkStatus.refetch,
    loading: loading || networkStatus === NetworkStatus.refetch,
    refetch: refetch,
  };
};

export default useQueryWithRetries;
